import React, { ElementType, forwardRef, ReactElement, Ref } from 'react'

import { PijmaComponentProps } from '@pijma/hero-types'

const PijmaComponentNonWrapped = <T extends keyof JSX.IntrinsicElements>(
  { as, commonProps, ...restProps }: PijmaComponentProps<T>,
  ref?: Ref<T>,
): ReactElement => {
  const Tag = as as ElementType

  let props = {
    ...restProps,
    'data-testid': commonProps.testId,
    style: { ...commonProps.style, ...restProps.style },
  }

  if (ref) {
    props = { ...props, ref }
  }
  return <Tag {...props} />
}

PijmaComponentNonWrapped.displayName = 'PijmaComponent'

export const PijmaComponent = forwardRef(PijmaComponentNonWrapped) as <
  T extends keyof JSX.IntrinsicElements,
>(
  props: PijmaComponentProps<T>,
  ref?: Ref<T>,
) => ReactElement
